export type CalendarDateValue = string | Date | null | undefined;

function parseCalendarDate(value: CalendarDateValue): Date | null {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : new Date(value);

  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (dateOnly) {
    return new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]));
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function toLocalDayStartInstant(value: CalendarDateValue): string | undefined {
  const date = parseCalendarDate(value);
  if (!date) return undefined;
  date.setHours(0, 0, 0, 0);
  return date.toISOString();
}

export function toExclusiveLocalDayEndInstant(value: CalendarDateValue): string | undefined {
  const date = parseCalendarDate(value);
  if (!date) return undefined;
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + 1);
  return date.toISOString();
}

export function fromStartInstant(value: CalendarDateValue): Date | null {
  const date = parseCalendarDate(value);
  if (!date) return null;
  date.setHours(0, 0, 0, 0);
  return date;
}

export function fromExclusiveEndInstant(value: CalendarDateValue): Date | null {
  const date = parseCalendarDate(value);
  if (!date) return null;
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() - 1);
  return date;
}

export function formatCalendarDate(value: CalendarDateValue, exclusiveEnd = false): string {
  const date = exclusiveEnd ? fromExclusiveEndInstant(value) : fromStartInstant(value);
  if (!date) return '-';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
